import Accordion from 'accordion-js';

class HideFooterBlocks {
  constructor() {
    this.hideBlocks();
  }

  hideBlocks() {
    const mq = window.matchMedia("(max-width: 640px)");

    if (!mq.matches || !document.querySelectorAll('.footer__block[data-type="menu"]').length) {
      return;
    }

    const selectors = {
      footerBlock: 'footer__block--menu',
      footerTrigger: 'footer__title',
      footerPanel: 'footer__menu',
    };
    const footerBlocks = Array.from(document.querySelectorAll('.footer__blocks'));

    const accordionSettings = {
      duration: 300,
      elementClass: selectors.footerBlock,
      triggerClass: selectors.footerTrigger,
      panelClass: selectors.footerPanel,
      showMultiple: true,
      beforeOpen: (currElement) => {
        currElement.querySelector('.footer__icon').classList.add('active');
      },
      beforeClose: (currElement) => {
        currElement.querySelector('.footer__icon').classList.remove('active');
      },
    };

    footerBlocks.forEach((el) => {
      new Accordion(el, accordionSettings);
    });
  }
}

export default HideFooterBlocks;
